/**
 * The MultiEntryInput offers way more control than we need or want for this
 * form, and all its params are required. We don't need to manage the state for
 * the input and the tags and format the items and pick their IDs; we just need
 * to get and set a list of strings. This wrapper handles state and hides extra
 * params so the keyword form can stay slim.
 */
import React, { useState } from 'react';
import MultiEntryInput from '@rsos/components/capstone/base/form/inputs/MultiEntryInput/MultiEntryInput';

type MultiInputItem = { value: string; id: string; isValid: boolean };

export interface KeywordMultiInputProps {
  values: string[];
  onChange: (newValues: string[]) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
  validator?: (value: string) => boolean;
  name: string;
  multiWordValues?: boolean;
  errors?: string | string[];
  onBlur?: (e: React.FocusEvent) => void;
}
export const KeywordMultiInput = ({
  values,
  onChange,
  errors,
  ...props
}: KeywordMultiInputProps) => {
  const [partialItem, setPartialItem] = useState('');
  const cumulativeItems = values.map(value => {
    return { value, id: value, isValid: true };
  });

  const setItems = (newItems: MultiInputItem[]) => {
    setPartialItem('');
    onChange(newItems.map(v => v.value));
  };

  const changePartialItem = (val: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPartialItem(val.currentTarget.value);
  };

  return (
    <MultiEntryInput
      value={partialItem}
      handleChange={changePartialItem}
      tags={cumulativeItems}
      setFieldValue={() => null}
      updateTags={setItems}
      placeholder=""
      label={null}
      prefixComponent={null}
      disabled={false}
      className=""
      validator={() => true}
      error={Array.isArray(errors) ? errors.join(', ') : errors}
      hiddenInputName={`${props.name}_hidden`}
      {...props}
    />
  );
};
